import { FetchPolicy } from '@apollo/client';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { domainServiceHelper } from 'global/services-helpers';
import { action, computed, makeObservable } from 'mobx';
import IProposalPageStore from 'store/modules/proposal/iProposalPageStore';
import { PortfolioItemsByProductLine } from 'store/modules/proposal/types';
import { ProposalItemsStore } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import { Cart } from 'types/cartServiceV2';
import { DomainProductLine } from 'types/domainServiceV2';

export default class RFQProposalPageStore extends IProposalPageStore {
  // TO_DO: Refactor into querying data from domain stores inside this store, rather than relying on other stores
  // (Page stores must be initial ones),
  initialStore: ProposalItemsStore;

  // TO_DO: Refactor that into separate ProposalModule
  public get userRoles(): SupportedUserRoles[] {
    return this.initialStore.rootStore.userStore.userRoles;
  }

  public get cartId(): string {
    // TO_DO: Refactor that into separate ProposalModule
    return this.initialStore.cart.id;
  }

  // TO_DO: Refactor that into separate ProposalModule
  public getPortfolioByProductLine(productLineId: ProductLineId): PortfolioItemsByProductLine {
    const result = this.initialStore.portfoliosByProductLine.find((item) => item.productLineId === productLineId);
    if (!result) {
      throw new Error(`Cannot find items for this product line id: ${productLineId}`);
    }
    return result;
  }

  // TO_DO: Refactor that into separate ProposalModule
  public async updateCustomPortfolioAndCart(cart: Cart, portfolioId: string): Promise<void> {
    await this.initialStore.updateCustomPortfolioAndCart(cart, portfolioId);
  }

  // TO_DO: Refactor that into separate ProposalModule
  public getDomainProductLine(productLineId: ProductLineId): DomainProductLine | undefined {
    return domainServiceHelper.getDomainProductLineById(productLineId, this.initialStore.productLines);
  }

  // TO_DO: Refactor that into separate ProposalModule
  public async updateCartItem(portfolioId: string, policy: FetchPolicy): Promise<void> {
    await this.initialStore.updateCartItem(this.initialStore.fullCart, portfolioId, policy);
  }

  constructor(proposalItemsStore: ProposalItemsStore) {
    super();
    this.initialStore = proposalItemsStore;
    makeObservable(this, {
      getDomainProductLine: action.bound,
      getPortfolioByProductLine: action.bound,
      updateCustomPortfolioAndCart: action.bound,
      userRoles: computed,
      cartId: computed,
    });
  }
}

// TO_DO: create separate access state hook instead of using rootStore hook
